module.exports = __webpack_public_path__ + "static/media/Twitter.f5c99a19.png";